import { getQueryParam } from 'helpers/path';
import { api } from './ApiService';

export const getMessage = (query) => {
  const queryParam = getQueryParam(query);

  return api.get(`/metadata/message${queryParam}`);
};

export const getMessageHash = (query) => {
  const queryParam = getQueryParam(query);

  return api.get(`/metadata/message/hash${queryParam}`, { isFullData: true });
};

export const updateMessage = (data) => {
  return api.put('/metadata/message', { ...data });
};
